import { __decorate } from "tslib";
//NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
setInteractionMode("passive");
import BaseMixer from "../BaseMixer";
//System one
import Layout from "../../layouts/auth.vue";
let FogotPassword = /** @class */ (() => {
    let FogotPassword = class FogotPassword extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Forgot Password";
            this.email = "";
        }
        SendPasswordResetRequest() {
            this.validate("forgorPasswordObserver").then((response) => {
                if (response) {
                    // UsersModule.SendResetPasswordRequest(this.email).then((response) => {
                    //  });
                }
            });
        }
    };
    FogotPassword = __decorate([
        Component({
            name: "SessionTimeOut",
            components: {
                Layout,
            },
        })
    ], FogotPassword);
    return FogotPassword;
})();
export default FogotPassword;
